import { ValidationRule } from 'react-hook-form';

export const requiredRule: ValidationRule<boolean> = {
    value: true,
    message: 'Это поле обязательное',
};
